module.exports = __webpack_public_path__ + "img/20190829151520857.cd29b3a0.jpg";